import { useConstraintMarkerLayerState } from "./useConstraintMarkerLayerState";
import { useConstraintMarkers } from "./useConstraintMarkers";
import { useConstraintVisualizationBridge } from "./useConstraintVisualizationBridge";
import { useTendonVisualization } from "./useTendonVisualization";

export function useSceneConstraintVisualizationController({
  allEqualities,
  allTendons,
  cameraRef,
  constraintHoveredKeyRef,
  constraintMarkerBuildRetryCountRef,
  constraintMarkerMeshesRef,
  constraintMarkersGroupRef,
  constraintPointerRef,
  constraintVisibilityUi,
  constraintVisualizationRef,
  equalityMarkerVisibility,
  focusBodyUuid,
  focusCollisionGeomUuid,
  focusMeshUuid,
  focusModeActive,
  jointObjectsRef,
  missingConstraintBodyToastKeysRef,
  rendererRef,
  sceneObjectsRef,
  sceneRef,
  selectedBodiesMultiKey,
  selectedEquality,
  selectedTendon,
  showConstraintMarkers,
  structureChangeTick,
  tendonMarkerVisibility,
  tendonVisualizationRef,
}) {
  const {
    constraintMarkerLayerStateRef,
    constraintMarkerLayerVisible,
    constraintMarkerSettings,
    constraintMarkersRetryNonce,
    setConstraintMarkersRetryNonce,
    tendonMarkerLayerVisible,
  } = useConstraintMarkerLayerState({
    constraintVisibilityUi,
    equalityMarkerVisibility,
    selectedEquality,
    selectedTendon,
    showConstraintMarkers,
    tendonMarkerVisibility,
  });

  useConstraintVisualizationBridge({
    sceneRef,
    sceneObjectsRef,
    constraintVisualizationRef,
    missingConstraintBodyToastKeysRef,
    constraintMarkerSettings,
    constraintMarkerLayerVisible,
    selectedEquality,
  });

  useTendonVisualization({
    sceneRef,
    rendererRef,
    tendonVisualizationRef,
    constraintMarkersGroupRef,
    constraintPointerRef,
    constraintHoveredKeyRef,
    constraintMarkerSettings,
    tendonMarkerLayerVisible,
    selectedTendon,
  });

  useConstraintMarkers({
    sceneRef,
    cameraRef,
    rendererRef,
    sceneObjectsRef,
    jointObjectsRef,
    constraintMarkersGroupRef,
    constraintMarkerMeshesRef,
    constraintHoveredKeyRef,
    constraintMarkerLayerStateRef,
    constraintPointerRef,
    constraintMarkerBuildRetryCountRef,
    constraintMarkerSettings,
    constraintMarkerLayerVisible,
    tendonMarkerLayerVisible,
    constraintVisibilityUi,
    equalityMarkerVisibility,
    tendonMarkerVisibility,
    selectedEquality,
    selectedTendon,
    allEqualities,
    allTendons,
    showConstraintMarkers,
    focusModeActive,
    focusBodyUuid,
    focusMeshUuid,
    focusCollisionGeomUuid,
    selectedBodiesMultiKey,
    structureChangeTick,
    constraintMarkersRetryNonce,
    setConstraintMarkersRetryNonce,
  });

  return {
    constraintMarkerLayerVisible,
    constraintMarkersRetryNonce,
    tendonMarkerLayerVisible,
  };
}
